var map = {
	"./busd.svg": 1996,
	"./crypto-pending.png": 1997,
	"./crypto-reject.png": 1998,
	"./crypto-success.png": 1999,
	"./direpay.svg": 2000,
	"./trx.svg": 2001,
	"./usdc.svg": 2002,
	"./usdt.svg": 2003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;